"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateABBucket = void 0;
const constants_1 = require("../constants");
const index_1 = require("./index");
const md5_1 = __importDefault(require("crypto-js/md5"));
const generateABBucket = () => {
    var _a;
    const cookies = (0, index_1.parseCookies)();
    const deviceUUID = ((_a = (0, index_1.jsonSafeGet)(cookies[constants_1.CookiesConstants.AUTH_V2], {})) === null || _a === void 0 ? void 0 : _a.device_uuid) || cookies[constants_1.CookiesConstants.DEVICE_UUID];
    if (!deviceUUID || deviceUUID.length !== 36) {
        console.log("Invalid deviceUUID: Must be 36 characters long");
        return null;
    }
    const lastTwoChars = (0, md5_1.default)(deviceUUID).toString().slice(-2);
    const hexValue = parseInt(lastTwoChars, 16);
    const bucketNumber = Math.ceil((hexValue / 255.0) * 10) || 1;
    return String(bucketNumber);
};
exports.generateABBucket = generateABBucket;
